import { render } from "./TableauBord.vue?vue&type=template&id=187e3eb3"
import script from "./TableauBord.vue?vue&type=script&lang=js"
export * from "./TableauBord.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__